import { render, staticRenderFns } from "./VueIframe.vue?vue&type=template&id=5f0b026c&scoped=true&"
import script from "./VueIframe.vue?vue&type=script&lang=js&"
export * from "./VueIframe.vue?vue&type=script&lang=js&"
import style0 from "./VueIframe.vue?vue&type=style&index=0&id=5f0b026c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b026c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0b026c')) {
      api.createRecord('5f0b026c', component.options)
    } else {
      api.reload('5f0b026c', component.options)
    }
    module.hot.accept("./VueIframe.vue?vue&type=template&id=5f0b026c&scoped=true&", function () {
      api.rerender('5f0b026c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueIframe.vue"
export default component.exports